import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setDataLayout } from "../../../store/slices/theme.slice";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { all_routes } from "../../../router/all_routes";
import {
  setMobileSidebar,
  toggleMiniSidebar,
} from "../../../store/slices/sidebar.slice";
import { AppDispatch, RootState } from "../../../store/store";
import { logout } from "../../../store/slices/auth.slice";
import authService from "../../../services/auth/auth.service";
import { setDataTheme } from "../../../store/slices/theme.slice";
import { useTranslation } from "react-i18next";
import { useEffect, useState, useRef } from "react";
import React from "react";
import { CompanyActivityDto, CompanyNotificationDto, NotificationResponseDto } from "../../../types/attendanceDto.types";
import dailyRecordService from "../../../services/dailyRecord/dailyRecord.service";
import notificationService from "../../../services/notification/notification.service";
import { Avatar, Button, message, Modal } from "antd";
import { useSocket } from "../../../hooks/useSocket";
import { useLeaves } from "../../../hooks/useLeaves";
import { getFileUrl } from "../../../utils/file.utils";
import { CheckOutlined, CloseOutlined, LoadingOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import ticketService from "../../../services/ticket/ticket.service";
import FileService from "../../../services/file/file.service";
import { handleApiError } from "../../../utils/errorHandler";
import { logo } from "../../../constants/images";
import superAdminService from "../../../services/super-admin/super-admin.service";
import { useTour } from "../../../hooks/useTour";
import { RolesEnum } from "../../../types/route.types";
import dayjs from "dayjs";
import userNotificationService from "../../../services/notification/userNotification.service";
import { UserNotificationItem } from "../../../types/userNotification.types";
import { useUserNotificationUnreadCount, userNotificationUnreadStore } from "../../../hooks/useUserNotificationUnreadCount";
import { useApprovalCounts, useIsApprovalReviewer } from "../../../hooks/useApprovalCounts";
import { getNotificationTargetRoute } from "../../../utils/notificationRoutes";

// Header ikonlarındaki sayı rozeti
const headerCountBadgeStyle: React.CSSProperties = {
  position: 'absolute',
  top: 2,
  right: 2,
  minWidth: 16,
  height: 16,
  padding: '0 4px',
  fontSize: 10,
  lineHeight: '16px',
  borderRadius: 8,
};



// Aktivite açıklamasındaki İngilizce durum kelimelerini Türkçe'ye çevir (izin/ticket bildirimleri)
const localizeActivityStatus = (description: string, type: string): string => {
  if (!description || typeof description !== 'string') return description ?? '';
  if (type !== 'leave_request' && type !== 'ticket_request') return description;
  return description
    .replace(/\*\*approved\*\*/g, '**onaylandı**')
    .replace(/\*\*rejected\*\*/g, '**reddedildi**')
    .replace(/\*\*pending\*\*/g, '**beklemede**')
    .replace(/approved/gi, 'onaylandı')
    .replace(/rejected/gi, 'reddedildi')
    .replace(/pending/gi, 'beklemede');
};

const Header: React.FC = () => {
  const routes = all_routes;
  const { t } = useTranslation();

  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const dataLayout = useSelector((state: RootState) => state.theme.dataLayout);
  //console.log(dataLayout);
  const [activities, setActivities] = useState<CompanyActivityDto[]>([]);
  const [notifications, setNotifications] = useState<NotificationResponseDto[]>([]);
  const [activeTab, setActiveTab] = useState<'mine' | 'activities' | 'notifications'>('mine');
  const [myNotifications, setMyNotifications] = useState<UserNotificationItem[]>([]);
  const [myNotificationsLoading, setMyNotificationsLoading] = useState(false);
  const { connected, on } = useSocket();
  const [isLoading, setIsLoading] = useState(false);
  const [loadingId, setLoadingId] = useState<number | null>(null);

  const [subOpen, setSubopen] = useState<any>("");
  const [subsidebar, setSubsidebar] = useState("");
  const { updateLeaveStatus } = useLeaves();

  const { user, companyId } = useSelector((state: RootState) => state.auth);
  const [selectedLeave, setSelectedLeave] = useState<CompanyActivityDto | null>(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState<CompanyActivityDto | null>(null);
  const [isTicketModalVisible, setIsTicketModalVisible] = useState(false);

  const notificationDropdownRef = useRef<HTMLDivElement>(null); // Bildirim dropdown'ı için ref

  const isAdmin = user?.role === "admin";
  const unreadNotificationCount = useUserNotificationUnreadCount();
  const isApprovalReviewer = useIsApprovalReviewer();
  const { total: pendingApprovalTotal } = useApprovalCounts();

  const showTicketModal = (activity: CompanyActivityDto) => {
    setSelectedTicket(activity);
    setIsTicketModalVisible(true);
  };

  const { startAppTour } = useTour();

  const handleStartTour = () => {
    startAppTour();
  };

  const hideTicketModal = () => {
    setSelectedTicket(null);
    setIsTicketModalVisible(false);
  };

  const handleApproveTicket = async () => {
    if (!selectedTicket) return;

    try {
      setIsLoading(true);
      //console.log("selectedTicket", selectedTicket);
      const response = await ticketService.approveTicket(selectedTicket?.extraData?.ticketId as number);
      if (response) {
        message.success(t('tickets.successTickets'));
        // Aktiviteleri güncelle
        if (companyId) {
          const response = await dailyRecordService.getCompanyActivity(companyId);
          const filteredActivities = response.filter(
            (activity: CompanyActivityDto) => activity.type === "ticket_request"
          );
          const sortedActivities = filteredActivities.sort(
            (a: CompanyActivityDto, b: CompanyActivityDto) =>
              new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
          );
          setActivities(sortedActivities);
        }
        hideModal();
      }
    } catch (error: any) {
      handleApiError(error, t);
    } finally {
      setIsLoading(false);
    }
  };
  const handleRejectTicket = async () => {
    if (!selectedTicket) return;

    try {
      setIsLoading(true);
      //console.log("selectedTicket", selectedTicket);
      const response = await ticketService.rejectTicket(selectedTicket?.extraData?.ticketId as number);
      if (response) {
        message.success(t('ticketsUserAdminPage.statusRejected'));
        // Aktiviteleri güncelle
        if (companyId) {
          const response = await dailyRecordService.getCompanyActivity(companyId);
          const filteredActivities = response.filter(
            (activity: CompanyActivityDto) => activity.type === "ticket_request"
          );
          const sortedActivities = filteredActivities.sort(
            (a: CompanyActivityDto, b: CompanyActivityDto) =>
              new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
          );
          setActivities(sortedActivities);
        }
        hideModal();
      }
    } catch (error: any) {
      handleApiError(error, t);
    } finally {
      setIsLoading(false);
    }
  };

  const handleStatusChange = async (leaveId: number, dto: any) => {
    try {
      setLoadingId(leaveId)
      setIsLoading(true);
      await updateLeaveStatus(leaveId, dto);
      message.success(t('leaves.successLeave'));
      if (companyId) {
        const response = await dailyRecordService.getCompanyActivity(companyId);
        const filteredActivities = response.filter(
          (activity: CompanyActivityDto) => activity.type === "leave_request"
        );
        const sortedActivities = filteredActivities.sort(
          (a: CompanyActivityDto, b: CompanyActivityDto) =>
            new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        );
        setActivities(sortedActivities);
      }
      setIsModalVisible(false);
    } catch (error: any) {
      handleApiError(error, t);
    } finally {
      setIsLoading(false);
      setLoadingId(null)
    }
  };

  const getActivityIcon = (type: string) => {
    switch (type) {
      case "check_in":
        return "ti ti-login";
      case "check_out":
        return "ti ti-logout";
      case "leave_request":
        return "ti ti-calendar";
      case "ticket_request":
        return "ti ti-ticket";
      case "field_mode_request":
        return "ti ti-map-pin";
      default:
        return "ti ti-clock";
    }
  };

  const getStatusIcon = (status: string | number) => {
    const statusStr = String(status);
    switch (statusStr) {
      case 'approved':
        return <CheckOutlined style={{ color: '#52c41a' }} />;
      case 'rejected':
        return <CloseOutlined style={{ color: '#ff4d4f' }} />;
      default:
        return <i className="ti ti-edit" style={{ color: '#faad14', fontSize: '22px' }} />;
    }
  };
  const showModal = (activity: CompanyActivityDto) => {
    setSelectedLeave(activity);
    setIsModalVisible(true);
  };

  const hideModal = () => {
    setSelectedLeave(null);
    setIsModalVisible(false);
  };



  const fetchCompanyActivity = async (currentCompanyId: string) => {
    try {
      if (user?.role === "admin" && currentCompanyId) {
        const response = await dailyRecordService.getCompanyActivity(currentCompanyId)
        const sortedActivities = response.sort(
          (a: CompanyActivityDto, b: CompanyActivityDto) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        );

        setActivities(sortedActivities)
      }
    } catch (error: any) {
      handleApiError(error, t);
    }
  }

  const fetchCompanyNotifications = async () => {
    try {
      if (user?.role === "admin") {
        const response = await notificationService.getCompanyNotifications();
        // Güvenli veri kontrolü
        const validNotifications = response.filter(notification =>
          notification &&
          notification.id &&
          notification.title &&
          notification.content &&
          notification.createdAt
        );
        const sortedNotifications = validNotifications.sort(
          (a: NotificationResponseDto, b: NotificationResponseDto) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        );
        setNotifications(sortedNotifications);
      }
    } catch (error: any) {
      // console.error('Notifications fetch error:', error);
      // Hata durumunda boş array set et
      setNotifications([]);
      handleApiError(error, t);
    }
  }

  // Kullanıcının kendisine gönderilmiş son bildirimler (tüm roller)
  const fetchMyNotifications = async () => {
    setMyNotificationsLoading(true);
    try {
      const response = await userNotificationService.getNotifications({ page: 1, limit: 10 });
      setMyNotifications(response?.items ?? []);
      if (typeof response?.unreadCount === 'number') {
        userNotificationUnreadStore.set(response.unreadCount);
      }
    } catch {
      setMyNotifications([]);
    } finally {
      setMyNotificationsLoading(false);
    }
  };

  const handleMyNotificationClick = (notification: UserNotificationItem) => {
    if (!notification.isRead) {
      setMyNotifications(prev =>
        prev.map(n => (n.id === notification.id ? { ...n, isRead: true, readAt: new Date().toISOString() } : n))
      );
      userNotificationService
        .markAsRead(notification.id)
        .then(res => userNotificationUnreadStore.set(res?.unreadCount ?? 0))
        .catch(() => userNotificationUnreadStore.refresh());
    }
    const target = getNotificationTargetRoute(notification.data, user?.permissions);
    navigate(target ?? routes.myNotifications);
  };

  const handleMarkAllMyNotificationsRead = async () => {
    try {
      await userNotificationService.markAllAsRead();
      userNotificationUnreadStore.set(0);
      setMyNotifications(prev =>
        prev.map(n => (n.isRead ? n : { ...n, isRead: true, readAt: new Date().toISOString() }))
      );
    } catch (error: any) {
      handleApiError(error, t);
    }
  };

  // Notification dropdown açıldığında hem activities hem de notifications'ları çek
  const handleNotificationDropdownShow = () => {
    fetchMyNotifications();
    if (user?.role === "admin") {
      fetchCompanyNotifications();
      if (companyId) {
        fetchCompanyActivity(companyId);
      }
    }
  };

  // useEffect(()=>{
  //   if(companyId){
  //     fetchCompanyActivity(companyId)
  //   }
  // },[companyId])

  useEffect(() => {
    const notificationElement = notificationDropdownRef.current;
    const handleDropdownShow = () => {
      handleNotificationDropdownShow();
    };

    if (notificationElement) {
      // Bootstrap 'show.bs.dropdown' event'ini dinle
      notificationElement.addEventListener('show.bs.dropdown', handleDropdownShow);
    }

    // Cleanup: component unmount olduğunda listener'ı kaldır
    return () => {
      if (notificationElement) {
        notificationElement.removeEventListener('show.bs.dropdown', handleDropdownShow);
      }
    };
  }, [companyId, user?.role, t]); // Bağımlılıkları güncelle

  useEffect(() => {
    if (connected) {
      // Sadece newActivity olayını dinle
      const handleNewActivity = (data: CompanyActivityDto) => {
        // Aktiviteyi listeye ekle
        setActivities(prev => {
          // Aynı ID'li aktivite zaten varsa, ekleme
          if (prev.some(a => a.id === data.id)) {
            return prev;
          }
          // Yeni aktiviteyi ekle
          const newActivities = [data, ...prev];

          return newActivities;
        });
      }
      // Sadece newActivity dinleyicisini ekle
      on("newActivity", handleNewActivity);
    }
  }, [connected, on]);


  const mobileSidebar = useSelector(
    (state: any) => state.sidebar.mobileSidebar
  );

  const toggleMobileSidebar = () => {
    dispatch(setMobileSidebar(!mobileSidebar));
  };

  const handleToggleMiniSidebar = () => {
    if (dataLayout === "mini_layout") {
      dispatch(setDataLayout("default_layout"));
      localStorage.setItem("dataLayout", "default_layout");
    } else {
      dispatch(toggleMiniSidebar());
    }
  };

  const handleLogout = async () => {
    try {
      await dispatch(logout());
      navigate(routes.login2);
    } catch (error) {
      handleApiError(error, t);
    }
  };

  // İmpersonation bar: buton Header içinde olmayacak; global shell'de (Feature) gösteriliyor.
  // Ancak profil dropdown içinde (yalnızca admin görünür) bir kısayol ekleyebiliriz.
  const handleReturnToSuperAdmin = async () => {
    try {
      await superAdminService.stopImpersonation();
    } catch {}

    const originalToken = localStorage.getItem('originalToken');
    const originalUser = localStorage.getItem('originalUser');
    const returnUrl = localStorage.getItem('originalReturnUrl') || '/super-admin/dashboard';
    if (originalToken && originalUser) {
      localStorage.setItem('token', originalToken);
      localStorage.setItem('user', originalUser);
      localStorage.removeItem('originalToken');
      localStorage.removeItem('originalUser');
      localStorage.removeItem('originalReturnUrl');
      window.location.assign(returnUrl);
      return;
    }
    window.location.assign('/super-admin/dashboard');
  };

  const [isFullscreen, setIsFullscreen] = useState(false);
  const toggleFullscreen = () => {
    if (!isFullscreen) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen().catch((err) => { });
        setIsFullscreen(true);
      }
    } else {
      if (document.exitFullscreen) {
        if (document.fullscreenElement) {
          document.exitFullscreen().catch((err) => { });
        }
        setIsFullscreen(false);
      }
    }
  };

  // const handleSidebarToggle = () => {
  //   if (window.innerWidth <= 991) {
  //     toggleMobileSidebar()
  //   }
  //   else {
  //     toggleSidebar
  //   }
  // };

  return (
    <div className={`header `}>
      <div className="main-header">
        <div className="header-left">
          <Link to={routes.adminDashboard} className="logo">
            <ImageWithBasePath src="assets/img/dinox-light.png" alt="Logo" />
          </Link>
          <Link to={routes.adminDashboard} className="dark-logo">
            <ImageWithBasePath src="assets/img/dinox-dark.png" alt="Logo" />
          </Link>
        </div>

        <Link
          id="mobile_btn"
          onClick={toggleMobileSidebar}
          className="mobile_btn"
          to="#sidebar"
          style={{
            padding: '0 8px'
          }}
        >
          {/* <span className="bar-icon">
            <span></span>
            <span></span>
            <span></span>
          </span> */}
          <img
            src={logo}
            style={{
              transform: mobileSidebar ? 'rotate(180deg)' : 'rotate(0deg)',
              transition: 'transform 0.3s ease'
            }}

          />
        </Link>

        <div className="header-user">
          <div className="nav user-menu nav-list">
            <div
              className="me-auto d-flex align-items-center"
              id="header-search"
            >
              <button
                // id="toggle_btn"
                onClick={handleToggleMiniSidebar}
                className="btn btn-menubar me-1"
              >
                <i className="ti ti-arrow-bar-to-left"></i>
              </button>
              {
                user?.role === "admin" && (
                  <Link to={routes.companySettings} className="btn btn-menubar">
                    <i className="ti ti-settings-cog"></i>
                  </Link>
                )
              }
            </div>

            {/* <LanguageSelector /> */}
            {/* <ThemeToggle /> */}

            <div className="d-flex align-items-center">
              <div className="me-1">
                <Link
                  to="#"
                  onClick={toggleFullscreen}
                  className="btn btn-menubar btnFullscreen"
                >
                  <i className="ti ti-maximize"></i>
                </Link>
              </div>
              {/* <div className="dropdown me-1">
                <Link
                  to="#"
                  className="btn btn-menubar"
                  data-bs-toggle="dropdown"
                >
                  <i className="ti ti-layout-grid-remove"></i>
                </Link>
                <div className="dropdown-menu dropdown-menu-end">
                  <div className="card mb-0 border-0 shadow-none">
                    <div className="card-header">
                      <h4>Applications</h4>
                    </div>
                    <div className="card-body">
                      <Link to={routes.calendar} className="d-block pb-2">
                        <span className="avatar avatar-md bg-transparent-dark me-2">
                          <i className="ti ti-calendar text-gray-9"></i>
                        </span>
                        Calendar
                      </Link>
                      <Link to={routes.todo} className="d-block py-2">
                        <span className="avatar avatar-md bg-transparent-dark me-2">
                          <i className="ti ti-subtask text-gray-9"></i>
                        </span>
                        To Do
                      </Link>
                      <Link to={routes.notes} className="d-block py-2">
                        <span className="avatar avatar-md bg-transparent-dark me-2">
                          <i className="ti ti-notes text-gray-9"></i>
                        </span>
                        Notes
                      </Link>
                      <Link to={routes.fileManager} className="d-block py-2">
                        <span className="avatar avatar-md bg-transparent-dark me-2">
                          <i className="ti ti-folder text-gray-9"></i>
                        </span>
                        File Manager
                      </Link>
                      <Link to={routes.kanbanView} className="d-block py-2">
                        <span className="avatar avatar-md bg-transparent-dark me-2">
                          <i className="ti ti-layout-kanban text-gray-9"></i>
                        </span>
                        Kanban
                      </Link>
                      <Link to={routes.invoice} className="d-block py-2 pb-0">
                        <span className="avatar avatar-md bg-transparent-dark me-2">
                          <i className="ti ti-file-invoice text-gray-9"></i>
                        </span>
                        Invoices
                      </Link>
                    </div>
                  </div>
                </div>
              </div> */}

              {isApprovalReviewer && (
                <div className="me-1">
                  <Link
                    to={routes.approvals}
                    className="btn btn-menubar position-relative"
                    title="Onaylar"
                  >
                    <i className="ti ti-checklist"></i>
                    {pendingApprovalTotal > 0 && (
                      <span className="badge bg-danger rounded-pill text-white" style={headerCountBadgeStyle}>
                        {pendingApprovalTotal > 99 ? '99+' : pendingApprovalTotal}
                      </span>
                    )}
                  </Link>
                </div>
              )}
              {
                user && (
                  <div className="me-1 notification_item" ref={notificationDropdownRef}>
                    <Link
                      to="#"
                      className="btn btn-menubar position-relative me-1"
                      id="notification_popup"
                      data-bs-toggle="dropdown"
                      data-tour="notifications"
                    >
                      <i className="ti ti-bell"></i>
                      {unreadNotificationCount > 0 ? (
                        <span className="badge bg-danger rounded-pill text-white" style={headerCountBadgeStyle}>
                          {unreadNotificationCount > 99 ? '99+' : unreadNotificationCount}
                        </span>
                      ) : (
                        isAdmin && (activities.length > 0 || notifications.length > 0) && (
                          <span className="notification-status-dot"></span>
                        )
                      )}
                    </Link>
                    <div className="dropdown-menu dropdown-menu-end notification-dropdown p-4">
                      <div className="d-flex align-items-center justify-content-between border-bottom p-0 pb-3 mb-3">
                        <h4 className="notification-title">{t('header.notifications')}</h4>
                      </div>

                      {/* Tab Navigation */}
                      <div className="nav nav-tabs border-bottom mb-3">
                        <button
                          className={`nav-link ${activeTab === 'mine' ? 'active' : ''}`}
                          onClick={(e) => {
                            e.stopPropagation();
                            setActiveTab('mine');
                          }}
                          style={{ border: 'none', background: 'none', padding: '8px 16px' }}
                        >
                          Bildirimlerim{unreadNotificationCount > 0 ? ` (${unreadNotificationCount})` : ''}
                        </button>
                        {isAdmin && (
                        <>
                        <button
                          className={`nav-link ${activeTab === 'activities' ? 'active' : ''}`}
                          onClick={(e) => {
                            e.stopPropagation();
                            setActiveTab('activities');
                          }}
                          style={{ border: 'none', background: 'none', padding: '8px 16px' }}
                        >
                          {t('header.activities')} ({activities.length})
                        </button>
                        <button
                          className={`nav-link ${activeTab === 'notifications' ? 'active' : ''}`}
                          onClick={(e) => {
                            e.stopPropagation();
                            setActiveTab('notifications');
                          }}
                          style={{ border: 'none', background: 'none', padding: '8px 16px' }}
                        >
                          {t('header.notifications')} ({notifications.length})
                        </button>
                        </>
                        )}
                      </div>

                      <div className="noti-content">
                        {activeTab === 'mine' && (
                          <div className="d-flex flex-column">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                              <span className="text-muted small">
                                {unreadNotificationCount > 0 ? `${unreadNotificationCount} okunmamış bildirim` : 'Okunmamış bildirim yok'}
                              </span>
                              {unreadNotificationCount > 0 && (
                                <button
                                  type="button"
                                  className="btn btn-link btn-sm p-0"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleMarkAllMyNotificationsRead();
                                  }}
                                >
                                  Tümünü okundu işaretle
                                </button>
                              )}
                            </div>
                            {myNotificationsLoading && myNotifications.length === 0 ? (
                              <div className="text-center py-3">
                                <LoadingOutlined style={{ fontSize: 20 }} />
                              </div>
                            ) : myNotifications.length > 0 ? (
                              myNotifications.map((notification) => (
                                <div
                                  key={notification.id}
                                  className="border-bottom mb-2 pb-2"
                                  role="button"
                                  onClick={() => handleMyNotificationClick(notification)}
                                  style={{
                                    cursor: 'pointer',
                                    padding: '8px',
                                    borderRadius: '4px',
                                    backgroundColor: notification.isRead ? 'transparent' : 'rgba(24, 144, 255, 0.08)',
                                  }}
                                >
                                  <div className="d-flex">
                                    <span className="avatar-lg me-2 flex-shrink-0">
                                      <i className={`ti ti-bell fs-3 ${notification.isRead ? 'text-muted' : 'text-primary'}`} />
                                    </span>
                                    <div className="flex-grow-1">
                                      <div className="d-flex justify-content-between align-items-start gap-2">
                                        <h6 className={`mb-1 ${notification.isRead ? 'fw-normal' : 'fw-semibold'}`}>
                                          {notification.title}
                                        </h6>
                                        {!notification.isRead && (
                                          <span
                                            className="bg-primary rounded-circle flex-shrink-0 mt-1"
                                            style={{ width: 8, height: 8, display: 'inline-block' }}
                                          />
                                        )}
                                      </div>
                                      <p className="mb-1 text-muted small" style={{ whiteSpace: 'pre-line' }}>
                                        {notification.content}
                                      </p>
                                      <span className="text-muted small">
                                        {dayjs(notification.createdAt).format('DD.MM.YYYY HH:mm')}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              ))
                            ) : (
                              <p className="text-center text-muted">{t('header.noNotifications')}</p>
                            )}
                          </div>
                        )}

                        {activeTab === 'activities' && (
                          <div className="d-flex flex-column">
                            {activities.length > 0 ? (
                              activities.map((activity) => (
                                <div
                                  key={activity.id}
                                  className={"border-bottom mb-3 pb-3"}
                                  onClick={activity.type === "field_mode_request" ? () => navigate(routes.fieldModeRequests) : undefined}
                                  style={activity.type === "field_mode_request" ? { cursor: "pointer" } : undefined}
                                >
                                  <div className="d-flex">
                                    <span className="avatar-lg me-2 flex-shrink-0">
                                      <i className={`${getActivityIcon(activity.type)} fs-3`} />
                                    </span>
                                    <div className="flex-grow-1">
                                      <p className="mb-1">
                                        {localizeActivityStatus(activity.description, activity.type)}
                                      </p>
                                      <span>{activity.createdAt.split('T')[0]}</span>
                                      {activity.type === "ticket_request" && (
                                        <div
                                          className="d-flex justify-content-start align-items-center mt-1"
                                          onClick={() => showTicketModal(activity)}
                                          style={{ cursor: 'pointer' }}
                                        >
                                          {activity?.extraData?.status === 'created' ? (
                                            <i className={'ti ti-hourglass'} style={{ color: '#faad14', fontSize: '22px' }}></i>
                                          ) : (
                                            <CheckOutlined style={{ color: '#52c41a' }} />
                                          )}
                                        </div>
                                      )}
                                      {activity.type === 'leave_request' && (
                                        <div
                                          className="d-flex justify-content-start align-items-center mt-1"
                                          onClick={() => showModal(activity)}
                                          style={{ cursor: 'pointer' }}
                                        >
                                          {loadingId === activity?.extraData?.leaveId ? (
                                            <LoadingOutlined style={{ fontSize: 16 }} />
                                          ) : (
                                            getStatusIcon(activity?.extraData?.status || 'pending')
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              ))
                            ) : (
                              <p className="text-center text-muted">{t('header.noActivities')}</p>
                            )}
                          </div>
                        )}

                        {activeTab === 'notifications' && (
                          <div className="d-flex flex-column">
                            {notifications.length > 0 ? (
                              notifications.map((notification) => (
                                <div
                                  key={notification.id}
                                  className={"border-bottom mb-3 pb-3 notification-item"}
                                  style={{
                                    cursor: 'pointer',
                                    transition: 'background-color 0.2s ease',
                                    padding: '8px',
                                    borderRadius: '4px'
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor = '#f8f9fa';
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = 'transparent';
                                  }}
                                  onClick={() => navigate(routes.notificationList)}
                                >
                                  <div className="d-flex">
                                    <span className="avatar-lg me-2 flex-shrink-0">
                                      <i className="ti ti-bell fs-3" />
                                    </span>
                                    <div className="flex-grow-1">
                                      <div className="d-flex justify-content-between align-items-start mb-1">
                                        <h6 className="mb-1 fw-semibold">
                                          {notification.title}
                                        </h6>
                                        <span className={`badge ${notification.priority === 'high' ? 'bg-danger' :
                                          notification.priority === 'medium' ? 'bg-warning' : 'bg-info'
                                          }`} style={{ fontSize: '12px' }}>
                                          {t(`header.priority.${notification.priority}`)}
                                        </span>
                                      </div>
                                      <p className="mb-1 text-muted small">
                                        {notification.content}
                                      </p>
                                      <div className="d-flex justify-content-between align-items-center">
                                        <span className="text-muted small">
                                          {notification.createdAt.split('T')[0]}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))
                            ) : (
                              <p className="text-center text-muted">{t('header.noNotifications')}</p>
                            )}
                          </div>
                        )}
                      </div>
                      <div className="d-flex p-0">
                        <Link to="#" className="btn btn-light w-100 me-2">
                          {t('header.cancel')}
                        </Link>
                        <Link
                          to={isAdmin && activeTab !== 'mine' ? routes.notificationList : routes.myNotifications}
                          className="btn btn-primary w-100"
                        >
                          {t('header.viewAll')}
                        </Link>
                      </div>
                    </div>
                  </div>
                )
              }
              {user?.role !== RolesEnum.SUPERADMIN && (
              <div className="dropdown main-profile me-3">
                <Link
                  to="#"
                  className="btn btn-link nav-link p-0 border-0 bg-transparent"
                  data-tour="tour-button"
                  onClick={handleStartTour}
                  title={t('tour.startTour')}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    transition: 'all 0.3s ease'
                  }}
                >
                  <QuestionCircleOutlined 
                    style={{ 
                      fontSize: '18px', 
                      color: '#666',
                      transition: 'color 0.3s ease' 
                    }} 
                    className="tour-icon"
                  />
                </Link>
              </div>
              )}
              <div className="dropdown profile-dropdown">
                <Link
                  to="#"
                  data-tour="profile-menu"
                  className="dropdown-toggle d-flex align-items-center"
                  data-bs-toggle="dropdown"
                >
                  <span className="avatar avatar-sm online">
                    <ImageWithBasePath
                      src={"assets/img/normal.png"}
                      alt="Img"
                      className="img-fluid rounded-circle"
                    />
                  </span>
                </Link>

                <div className="dropdown-menu shadow-none">
                  <div className="card mb-0">
                    <div className="card-header">
                      <div className="d-flex align-items-center">
                        <div className="avatar me-2">
                          {user?.profilePicture ? (
                            <Avatar src={getFileUrl(user.profilePicture)} size="large" />
                          ) : (
                            <Avatar src={user?.gender === 'male' ? '/assets/img/man.png' : '/assets/img/woman.png'} size="large" />
                          )}
                        </div>
                        <div>
                          <h5 className="mb-0">
                            {user?.firstName} {user?.lastName}
                          </h5>
                          <p className="fs-12 fw-medium mb-0">{user?.email}</p>
                        </div>
                      </div>
                    </div>
                    <div className="card-body">
                      <Link
                        className="dropdown-item d-inline-flex align-items-center p-0 py-2"
                        to={routes.profile}
                      >
                        <i className="ti ti-user-circle me-1"></i>{t('header.profile')}
                      </Link>
                      {user?.role === "admin" && (
                        <Link
                          className="dropdown-item d-inline-flex align-items-center p-0 py-2"
                          to={routes.companySettings}
                        >
                          <i className="ti ti-settings me-1"></i>{t('header.settings')}
                        </Link>
                      )}
                      {/* İmpersonation modundan çık */}
                      {localStorage.getItem('originalToken') && localStorage.getItem('originalUser') && (
                        <button
                          className="dropdown-item d-inline-flex align-items-center p-0 py-2"
                          onClick={handleReturnToSuperAdmin}
                        >
                          <i className="ti ti-arrow-back-up me-2"></i>Süper Admin’e Dön
                        </button>
                      )}
                    </div>
                    <div className="card-footer">
                      <button
                        onClick={handleLogout}
                        className="dropdown-item d-inline-flex align-items-center p-0 py-2"
                      >
                        <i className="ti ti-login me-2"></i>{t('header.logout')}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="dropdown mobile-user-menu">
          <Link
            to="#"
            data-tour="profile"
            className="nav-link dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fa fa-ellipsis-v"></i>
          </Link>
          <div className="dropdown-menu dropdown-menu-end">
            <Link className="dropdown-item" to={routes.profile} >
              {t('header.profile')}
            </Link>
            {user?.role === "admin" && (
              <Link className="dropdown-item" to={routes.companySettings}>
                {t('header.settings')}
              </Link>
            )}
            <Link className="dropdown-item" to={routes.login2} onClick={handleLogout}>
              {t('header.logout')}
            </Link>
          </div>
        </div>
      </div>
      <Modal
        title={
          <div className="d-flex align-items-center border-bottom pb-3">
            <div className="d-flex align-items-center flex-grow-1">
              <span className={`badge ${selectedLeave?.extraData?.status === 'pending' ? 'bg-warning' : selectedLeave?.extraData?.status === 'approved' ? 'bg-success' : 'bg-danger'} me-3`} style={{ fontSize: '1rem', padding: '8px 12px' }}>
                #{selectedLeave?.extraData?.leaveId}
              </span>
              <h5 className="mb-0">{selectedLeave ? localizeActivityStatus(selectedLeave.description, selectedLeave.type) : ''}</h5>
            </div>
          </div>
        }
        open={isModalVisible}
        onCancel={hideModal}
        footer={[
          <Button key="close" onClick={hideModal}>
            {t("dashboard.leaveRequests.close")}
          </Button>,
          selectedLeave?.extraData?.status === 'pending' && (
            <>
              <Button
                key="reject"
                danger
                loading={isLoading}
                onClick={() => handleStatusChange(Number(selectedLeave.extraData?.leaveId), { status: 'rejected' })}
              >
                {t("dashboard.leaveRequests.reject")}
              </Button>
              <Button
                key="approve"
                type="primary"
                loading={isLoading}
                onClick={() => handleStatusChange(Number(selectedLeave.extraData?.leaveId), { status: 'approved' })}
              >
                {t("dashboard.leaveRequests.approve")}
              </Button>
            </>
          )
        ]}
        width={700}
      >
        <div className="leave-details-modal">
          <div className="user-info mb-4 p-3 bg-light rounded">
            <div className="d-flex align-items-center">
              <div className="avatar-wrapper me-3">
                <ImageWithBasePath
                  src={selectedLeave?.user.avatar || "assets/img/profiles/avatar-01.jpg"}
                  alt="User"
                  className="avatar avatar-md rounded-circle border border-2 shadow-sm"
                />
              </div>
              <div className="user-details flex-grow-1">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h6 className="mb-1">{selectedLeave?.user.firstName} {selectedLeave?.user.lastName}</h6>
                    <p className="text-muted mb-0 small">{selectedLeave?.user.email}</p>
                  </div>
                  <div className="text-end">
                    <p className="mb-0 text-muted small">
                      <i className="ti ti-calendar me-1"></i>
                      {selectedLeave && new Date(selectedLeave.createdAt).toLocaleDateString('tr-TR', {
                        day: '2-digit',
                        month: 'long',
                        year: 'numeric'
                      })}
                    </p>
                    <p className="mb-0 text-muted small">
                      <i className="ti ti-clock me-1"></i>
                      {selectedLeave && new Date(selectedLeave.createdAt).toLocaleTimeString('tr-TR', {
                        hour: '2-digit',
                        minute: '2-digit'
                      })}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="leave-content">
            <div className="section mb-4">
              <h6 className="text-primary mb-3">
                <i className="ti ti-file-description me-2"></i>
                {t("dashboard.leaveRequests.description")}
              </h6>
              <div className="description p-3 border rounded bg-white">
                <p className="mb-0" style={{ lineHeight: '1.6' }}>
                  {selectedLeave ? (localizeActivityStatus(selectedLeave.description, selectedLeave.type) || t("dashboard.leaveRequests.noDescription")) : t("dashboard.leaveRequests.noDescription")}
                </p>
              </div>
            </div>

            {selectedLeave?.extraData?.documentUrl && (
              <div className="section mb-4">
                <h6 className="text-primary mb-3">
                  <i className="ti ti-file me-2"></i>
                  {t("dashboard.leaveRequests.document")}
                </h6>
                <div className="document p-3 border rounded bg-white">
                  <a
                    href="#"
                    onClick={async (e) => {
                      e.preventDefault();
                      try {
                        await FileService.getInstance().viewFileAsBlob(selectedLeave?.extraData?.documentUrl as string);
                      } catch (error) {
                        message.error('Belge görüntülenirken hata oluştu');
                      }
                    }}
                    className="btn btn-light btn-sm"
                  >
                    <i className="ti ti-file-download me-2"></i>
                    {t("dashboard.leaveRequests.viewDocument")}
                  </a>
                </div>
              </div>
            )}

            <div className="section mb-4">
              <h6 className="text-primary mb-3">
                <i className="ti ti-info-circle me-2"></i>
                {t("dashboard.leaveRequests.statusInfo")}
              </h6>
              <div className="status-info p-3 border rounded bg-white">
                <div className="d-flex align-items-center">
                  <span
                    className={`status-indicator ${selectedLeave?.extraData?.status === 'pending' ? 'bg-warning' : selectedLeave?.extraData?.status === 'approved' ? 'bg-success' : 'bg-danger'} me-2`}
                    style={{ width: '10px', height: '10px', borderRadius: '50%', display: 'inline-block' }}
                  ></span>
                  <span className="status-text">
                    {selectedLeave?.extraData?.status === 'pending'
                      ? t("dashboard.leaveRequests.pending")
                      : selectedLeave?.extraData?.status === 'approved'
                        ? t("dashboard.leaveRequests.approved")
                        : t("dashboard.leaveRequests.rejected")}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        title={
          <div className="d-flex align-items-center border-bottom pb-3">
            <div className="d-flex align-items-center flex-grow-1">
              <span className="badge bg-warning me-3" style={{ fontSize: '1rem', padding: '8px 12px' }}>
                #{selectedTicket?.id}
              </span>
              <h5 className="mb-0">{selectedTicket?.description}</h5>
            </div>
          </div>
        }
        open={isTicketModalVisible}
        onCancel={hideTicketModal}
        footer={[
          <Button key="close" onClick={hideTicketModal}>
            {t("common.buttons.close")}
          </Button>,
          selectedTicket?.extraData?.status === 'pending' && (
            <>
              <Button
                key="approve"
                type="primary"
                loading={isLoading}
                onClick={handleApproveTicket}
              >
                {t("ticketsUserAdminPage.approveTicket")}
              </Button>
              <Button
                key="reject"
                danger
                loading={isLoading}
                onClick={handleRejectTicket}
              >
                {t("ticketsUserAdminPage.rejectTicket")}
              </Button>
            </>
          )
        ]}
        width={700}
      >
        <div className="ticket-details-modal">
          <div className="user-info mb-4 p-3 bg-light rounded">
            <div className="d-flex align-items-center">
              <div className="avatar-wrapper me-3">
                <ImageWithBasePath
                  src={selectedTicket?.user.avatar || "assets/img/profiles/avatar-01.jpg"}
                  alt="User"
                  className="avatar avatar-md rounded-circle border border-2 shadow-sm"
                />
              </div>
              <div className="user-details flex-grow-1">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h6 className="mb-1">{selectedTicket?.user.firstName} {selectedTicket?.user.lastName}</h6>
                    <p className="text-muted mb-0 small">{selectedTicket?.user.email}</p>
                  </div>
                  <div className="text-end">
                    <p className="mb-0 text-muted small">
                      <i className="ti ti-calendar me-1"></i>
                      {selectedTicket && new Date(selectedTicket.createdAt).toLocaleDateString('tr-TR', {
                        day: '2-digit',
                        month: 'long',
                        year: 'numeric'
                      })}
                    </p>
                    <p className="mb-0 text-muted small">
                      <i className="ti ti-clock me-1"></i>
                      {selectedTicket && new Date(selectedTicket.createdAt).toLocaleTimeString('tr-TR', {
                        hour: '2-digit',
                        minute: '2-digit'
                      })}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="ticket-content">
            <div className="section mb-4">
              <h6 className="text-primary mb-3">
                <i className="ti ti-file-description me-2"></i>
                {t("dashboard.ticketRequests.description")}
              </h6>
              <div className="description p-3 border rounded bg-white">
                <p className="mb-0" style={{ lineHeight: '1.6' }}>
                  {selectedTicket?.description || t("dashboard.ticketRequests.noDescription")}
                </p>
              </div>
            </div>

            <div className="section mb-4">
              <h6 className="text-primary mb-3">
                <i className="ti ti-info-circle me-2"></i>
                {t("dashboard.ticketRequests.statusInfo")}
              </h6>
              <div className="status-info p-3 border rounded bg-white">
                <div className="d-flex align-items-center">
                  <span
                    className={`status-indicator ${selectedTicket?.extraData?.status === 'created' ? 'bg-warning' : 'bg-success'} me-2`}
                    style={{ width: '10px', height: '10px', borderRadius: '50%', display: 'inline-block' }}
                  ></span>
                  <span className="status-text">
                    {selectedTicket?.extraData?.status === 'created'
                      ? t("dashboard.ticketRequests.created")
                      : t("dashboard.ticketRequests.solved")}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Header;
